"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _styles = require("@mui/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function useResolutionCheck() {
  var theme = (0, _styles.useTheme)();
  var isTablet = (0, _useMediaQuery["default"])(theme.breakpoints.down('md'));
  var isMobile = (0, _useMediaQuery["default"])(theme.breakpoints.down('sm'));
  var isSmallDevice = (0, _useMediaQuery["default"])(theme.breakpoints.down('xs'));
  var isDesktop = (0, _useMediaQuery["default"])(theme.breakpoints.up('md'));
  return {
    isMobile: isMobile,
    isTablet: isTablet,
    isDesktop: isDesktop,
    isSmallDevice: isSmallDevice
  };
}
var _default = exports["default"] = useResolutionCheck;